import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import getManageUsersSidebarLinks from '../../../helpers/users/manageUsers/getManageUsersSidebarLinks'

class ManageUsersSidebar extends Component {

  SidebarLink({ name, link }) {
    return (
      <ul>
        <li><NavLink to={link}>{name}</NavLink></li>
      </ul>
    )
  }

  render() {
    const { user } = this.props
    const sidebarLinks = getManageUsersSidebarLinks(user)
    return (
      <div>
        {
          sidebarLinks.map(({ name, link }) =>
            <this.SidebarLink
              name={name}
              link={link}
              key={name + link}
            />
          )
        }
      </div>
    )
  }
}

export default ManageUsersSidebar


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManageUsersSidebar.js